export default __webpack_public_path__ + "static/media/PAIA-2025.5ab6c5ea.pdf";